const downloadHost = "https://get.tendra.sh";

export function downloadCommandFor(
  entityType: "connector" | "gateway",
): string {
  return [
    "arch=$(uname -m | sed 's/x86_64/amd64/;s/aarch64/arm64/')",
    "curl -fsSL \\",
    `  "${downloadHost}/${entityType}/latest/t4a-linux-$arch" \\`,
    "  -o t4a && chmod +x t4a",
  ].join("\n");
}

export function verifyCommandFor(entityType: "connector" | "gateway"): string {
  return [
    "arch=$(uname -m | sed 's/x86_64/amd64/;s/aarch64/arm64/')",
    "curl -fsSL \\",
    `  "${downloadHost}/${entityType}/latest/t4a-linux-$arch.sigstore.json" \\`,
    "  -o t4a.sigstore.json",
    "cosign verify-blob --bundle t4a.sigstore.json \\",
    "  --certificate-identity-regexp '^https://github.com/tendra-sh/tendra/' \\",
    "  --certificate-oidc-issuer https://token.actions.githubusercontent.com \\",
    "  t4a",
  ].join("\n");
}

export function installCommandFor(token: string): string {
  return `sudo ./t4a --install ${token}`;
}
